export const uk = {
  translation: {
    //content
    "About-exp": "Досвід:",
    "About-exp-details": `Я проста та відкрита людина. Оптиміст із почуттям гумору (але це не точно). Обожнюю людей — комунікація з іншими є моїм козирем. Перш за все ціную в людях чесність і скромність. Стресостійкий, хоча й не люблю стресові ситуації (думаю, як і всі ми). Найближча мета — стати фулстек-інженером. Мрія — одного дня працювати в геймдеві. Мої основні інтереси — комп’ютерна техніка, програмування, ігри та трохи спорту. З музики слухаю все, окрім шансону. Люблю дивитися фільми. Улюблений жанр — фантастика.`,
    "About-me": "Про себе:",
    "About-me-details": `Я проста та відкрита людина. Оптиміст з почуттям гумору (але це не точно). Обожнюю людей, комунікація з іншими це мій козир. Понад усе, ціную в людях чесність і скромність. Стресостійкий, хоча і не люблю стресові ситуації (думаю як і всі ми). Люблю вчитися і завжди готовий до нового. Найближча ціль - стати фулстак інженером. Мої основні інтереси - комп'ютерна техніка, програмування, ігри та трошки спорт. З музики слухаю все, окрім шансону. Люблю дивитися фільми, улюблений жанр фантастика.`,
    "Projects page": "Строінка projects",
    "Contact page": "Моя контактна інформація",
    "Greetings": `Привіт! Я Віталій. Для друзів - просто Віто.`,
    "Live": "Я живу ",
    "Live-country": "в Україні",
    "Live-earth": "на планеті Земля",
    "Live-galaxy": "в галактиці Чумацький Шлях",
    "Live-universe": "в нашому всесвіті",
    "Hero-description":
      'Моє кредо: "Життя є рух. Зупинитись можна лише якщо милуєшся красою."',
    "Email": "Мій майл:",
    "Phone": "Мій телефон:",
    "niagara-mobile": "Веб версія та мобільний застосунок для клієнтів Niagara Club",
    "lkames": "Сайт візитівка невеликої кошторисної компанії Lkames",
    "bp-manager": "Простий менеджер для збору бонусних очок у GTA 5 RP",
    "description-website":
      "Цей сайт портфоліо використовує стек React + Firebase",
    "another-projects": "Мої інші проекти:",
    "snake-game": "Проста гра. Мій пет-проект.",
    //UI titles
    "[btn-name] About": "Про мене",
    "[btn-name] Projects": "Мої проекти",
    "[btn-name] Contact": "Контакти",
    "[option-name] Language": "Мова: ",
    "theme-status-dark": "Світла тема",
    "theme-status-light": "Темна тема"
  },
};
